import { Injectable, signal } from '@angular/core';
import { RouteIdentifierNames } from 'app/core/models/route-identifiers/route-identifiers.model';

export type MenuCounts = Partial<Record<RouteIdentifierNames, number>>;

/**
 * Live "needs your action" counts shown as a pill on sidenav items, keyed by
 * the item's routeIdentifier. Features write their counts here (the sidenav
 * lives in `ui` and cannot import a feature); a missing or zero count shows
 * nothing.
 */
@Injectable({ providedIn: 'root' })
export class MenuCountsService {
  private readonly state = signal<MenuCounts>({});
  readonly counts = this.state.asReadonly();

  set(counts: MenuCounts): void {
    this.state.update((current) => ({ ...current, ...counts }));
  }

  clear(ids: RouteIdentifierNames[]): void {
    this.state.update((current) => {
      const next = { ...current };
      ids.forEach((id) => delete next[id]);
      return next;
    });
  }
}
